import React, { useEffect, useState } from "react";
import {
  fetchPrelaunchTokens,
  addPrelaunchToken,
  removePrelaunchToken,
  updatePrelaunchToken,
  setPrelaunchTokenLive,
} from "./prelaunchApi";

const PrelaunchTokenManager = () => {
  const [chainId, setChainId] = useState(56);

  // Add form
  const [tokenAddress, setTokenAddress] = useState("");
  const [symbol, setSymbol] = useState("");
  const [name, setName] = useState("");
  const [image, setImage] = useState("");
  const [listedDate, setListedDate] = useState("");
  const [liveDate, setLiveDate] = useState("");
  const [initialPrice, setInitialPrice] = useState("");
  const [initialMarketCap, setInitialMarketCap] = useState("");
  const [isLive, setIsLive] = useState(false);
  const [description, setDescription] = useState("");
const [website, setWebsite] = useState("");
const [twitter, setTwitter] = useState("");
const [telegram, setTelegram] = useState("");
const [discord, setDiscord] = useState("");


  // List state
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  // Editing state
  const [editingKey, setEditingKey] = useState(null);
  const [editForm, setEditForm] = useState({
    symbol: "",
    name: "",
    image: "",
    listedDate: "",
    liveDate: "",
    initialPrice: "",
    initialMarketCap: "",
    isLive: false,
     // ✅ new fields
  description: "",
  website: "",
  twitter: "",
  telegram: "",
  discord: "",
  });

  const reload = async () => {
    setLoading(true);
    setMsg("");
    try {
      const data = await fetchPrelaunchTokens(chainId);
      setItems(data);
    } catch (e) {
      setMsg(`❌ ${e.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    reload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chainId]);

  const onAdd = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg("");
    try {
      await addPrelaunchToken({
        chainId,
        tokenAddress,
        symbol,
        name,
        image,
        listedDate: listedDate || null,
        liveDate: liveDate || null,
        initialPrice,
        initialMarketCap,
        isLive,
        // ✅ new fields
  description,
  website,
  twitter,
  telegram,
  discord,
      });

      setMsg("✅ Token added");
      setTokenAddress("");
      setSymbol("");
      setName("");
      setImage("");
      setListedDate("");
      setLiveDate("");
      setInitialPrice("");
      setInitialMarketCap("");
      setDescription("");
setWebsite("");
setTwitter("");
setTelegram("");
setDiscord("");

      setIsLive(false);

      await reload();
    } catch (e2) {
      setMsg(`❌ ${e2.message}`);
    } finally {
      setLoading(false);
    }
  };

  const onRemove = async (t) => {
    setLoading(true);
    setMsg("");
    try {
      await removePrelaunchToken(t.chainId, t.tokenAddress);
      setMsg("✅ Token removed");
      await reload();
    } catch (e) {
      setMsg(`❌ ${e.message}`);
    } finally {
      setLoading(false);
    }
  };

  const startEdit = (t) => {
    const key = `${t.chainId}-${t.tokenAddress}`;
    setEditingKey(key);
    setEditForm({
      symbol: t.symbol || "",
      name: t.name || "",
      image: t.image || "",
      listedDate: t.listedDate || "",
      liveDate: t.liveDate || "",
      initialPrice: t.initialPrice ?? "",
      initialMarketCap: t.initialMarketCap ?? "",
      isLive: !!t.isLive,
      // ✅ new fields
  description: t.description || "",
  website: t.website || "",
  twitter: t.twitter || "",
  telegram: t.telegram || "",
  discord: t.discord || "",
    });
  };

  const cancelEdit = () => {
    setEditingKey(null);
    setEditForm({
      symbol: "",
      name: "",
      image: "",
      listedDate: "",
      liveDate: "",
      initialPrice: "",
      initialMarketCap: "",
      isLive: false,
      // ✅ new fields
  description: "",
  website: "",
  twitter: "",
  telegram: "",
  discord: "",
    });
  };

  const saveEdit = async (t) => {
    setLoading(true);
    setMsg("");
    try {
      // Send only what you want to update (this sends all editForm fields)
      await updatePrelaunchToken(t.chainId, t.tokenAddress, {
        symbol: editForm.symbol,
        name: editForm.name,
        image: editForm.image,
        listedDate: editForm.listedDate || null,
        liveDate: editForm.liveDate || null,
        initialPrice: editForm.initialPrice,
        initialMarketCap: editForm.initialMarketCap,
        isLive: editForm.isLive,
        // ✅ new fields
  description: editForm.description,
  website: editForm.website,
  twitter: editForm.twitter,
  telegram: editForm.telegram,
  discord: editForm.discord,
      });

      setMsg("✅ Token updated");
      setEditingKey(null);
      await reload();
    } catch (e) {
      setMsg(`❌ ${e.message}`);
    } finally {
      setLoading(false);
    }
  };

  const toggleLive = async (t) => {
    setLoading(true);
    setMsg("");
    try {
      const nextLive = !t.isLive;
      // If turning live ON, you can set liveDate automatically or ask user to edit it
      await setPrelaunchTokenLive(
        t.chainId,
        t.tokenAddress,
        nextLive,
        nextLive ? (t.liveDate || new Date().toISOString().slice(0, 10)) : null
      );

      setMsg(nextLive ? "✅ Token is LIVE now" : "✅ Token set to NOT live");
      await reload();
    } catch (e) {
      setMsg(`❌ ${e.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="border p-3 rounded-md bg-gray-50 mt-6">
      <h3 className="font-medium text-gray-700 mb-3">🚀 Prelaunch Tokens Manager</h3>

      {/* Add Form */}
      <form onSubmit={onAdd} className="space-y-2">
        <div className="grid grid-cols-2 gap-2">
          <input
            className="border rounded-md p-2"
            value={chainId}
            onChange={(e) => setChainId(Number(e.target.value))}
            placeholder="chainId (e.g. 56)"
            type="number"
            required
          />
          <input
            className="border rounded-md p-2"
            value={tokenAddress}
            onChange={(e) => setTokenAddress(e.target.value)}
            placeholder="tokenAddress (0x...)"
            required
          />
        </div>

        <div className="grid grid-cols-2 gap-2">
          <input className="border rounded-md p-2" value={symbol} onChange={(e) => setSymbol(e.target.value)} placeholder="symbol" />
          <input className="border rounded-md p-2" value={name} onChange={(e) => setName(e.target.value)} placeholder="name" />
        </div>

        <input className="border rounded-md p-2 w-full" value={image} onChange={(e) => setImage(e.target.value)} placeholder="image url" />

        <textarea
  className="border rounded-md p-2 w-full"
  value={description}
  onChange={(e) => setDescription(e.target.value)}
  placeholder="description"
  rows={3}
/>

<div className="grid grid-cols-2 gap-2">
  <input
    className="border rounded-md p-2"
    value={website}
    onChange={(e) => setWebsite(e.target.value)}
    placeholder="website (https://...)"
  />
  <input
    className="border rounded-md p-2"
    value={twitter}
    onChange={(e) => setTwitter(e.target.value)}
    placeholder="twitter (https://x.com/...)"
  />
</div>

<div className="grid grid-cols-2 gap-2">
  <input
    className="border rounded-md p-2"
    value={telegram}
    onChange={(e) => setTelegram(e.target.value)}
    placeholder="telegram (https://t.me/...)"
  />
  <input
    className="border rounded-md p-2"
    value={discord}
    onChange={(e) => setDiscord(e.target.value)}
    placeholder="discord (https://discord.gg/...)"
  />
</div>


        <div className="grid grid-cols-2 gap-2">
          <input className="border rounded-md p-2" value={listedDate} onChange={(e) => setListedDate(e.target.value)} placeholder="listedDate (YYYY-MM-DD)" />
          <input className="border rounded-md p-2" value={liveDate} onChange={(e) => setLiveDate(e.target.value)} placeholder="liveDate (YYYY-MM-DD)" />
        </div>

        <div className="grid grid-cols-2 gap-2">
          <input className="border rounded-md p-2" value={initialPrice} onChange={(e) => setInitialPrice(e.target.value)} placeholder="initialPrice" />
          <input className="border rounded-md p-2" value={initialMarketCap} onChange={(e) => setInitialMarketCap(e.target.value)} placeholder="initialMarketCap" />
        </div>

        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" checked={isLive} onChange={(e) => setIsLive(e.target.checked)} />
          isLive
        </label>

        <button disabled={loading} className="w-full bg-green-600 text-white py-2 rounded-md hover:bg-green-700 transition" type="submit">
          {loading ? "Working..." : "Add Prelaunch Token"}
        </button>
      </form>

      {/* List */}
      <div className="mt-6 flex items-center justify-between">
        <h4 className="font-medium text-gray-700">Current Tokens</h4>
        <button type="button" onClick={reload} className="text-sm text-blue-600 hover:underline" disabled={loading}>
          Refresh
        </button>
      </div>

      <div className="mt-2 space-y-2">
        {items.map((t) => {
          const key = `${t.chainId}-${t.tokenAddress}`;
          const isEditing = editingKey === key;

          return (
            <div key={key} className="bg-white border rounded-md p-3">
              <div className="flex items-start justify-between gap-3">
                <div className="text-sm">
                  <div className="font-medium">
                    {t.symbol || "?"} — {t.name || ""}{" "}
                    <span className={`ml-2 text-xs px-2 py-1 rounded ${t.isLive ? "bg-green-100" : "bg-yellow-100"}`}>
                      {t.isLive ? "LIVE" : "PRELAUNCH"}
                    </span>
                  </div>
                  <div className="text-gray-600 break-all">
                    {t.tokenAddress} (chainId: {t.chainId})
                  </div>
                  <div className="text-gray-600">
                    listedDate: {t.listedDate || "-"} | liveDate: {t.liveDate || "-"}
                  </div>
                </div>

                <div className="flex gap-2 flex-wrap justify-end">
                  <button
                    disabled={loading}
                    onClick={() => toggleLive(t)}
                    className="text-sm bg-purple-600 text-white px-3 py-1 rounded-md hover:bg-purple-700"
                  >
                    {t.isLive ? "Unlive" : "Make Live"}
                  </button>

                  {!isEditing ? (
                    <button
                      disabled={loading}
                      onClick={() => startEdit(t)}
                      className="text-sm bg-blue-600 text-white px-3 py-1 rounded-md hover:bg-blue-700"
                    >
                      Edit
                    </button>
                  ) : (
                    <>
                      <button
                        disabled={loading}
                        onClick={() => saveEdit(t)}
                        className="text-sm bg-green-600 text-white px-3 py-1 rounded-md hover:bg-green-700"
                      >
                        Save
                      </button>
                      <button
                        disabled={loading}
                        onClick={cancelEdit}
                        className="text-sm bg-gray-300 text-gray-800 px-3 py-1 rounded-md hover:bg-gray-400"
                      >
                        Cancel
                      </button>
                    </>
                  )}

                  <button
                    disabled={loading}
                    onClick={() => onRemove(t)}
                    className="text-sm bg-red-600 text-white px-3 py-1 rounded-md hover:bg-red-700"
                  >
                    Remove
                  </button>
                </div>
              </div>

              {/* Edit panel */}
              {isEditing && (
                <div className="mt-3 grid grid-cols-2 gap-2">
                  <input className="border rounded-md p-2" value={editForm.symbol} onChange={(e) => setEditForm({ ...editForm, symbol: e.target.value })} placeholder="symbol" />
                  <input className="border rounded-md p-2" value={editForm.name} onChange={(e) => setEditForm({ ...editForm, name: e.target.value })} placeholder="name" />
                  <input className="border rounded-md p-2 col-span-2" value={editForm.image} onChange={(e) => setEditForm({ ...editForm, image: e.target.value })} placeholder="image url" />
                  <input className="border rounded-md p-2" value={editForm.listedDate} onChange={(e) => setEditForm({ ...editForm, listedDate: e.target.value })} placeholder="listedDate (YYYY-MM-DD)" />
                  <input className="border rounded-md p-2" value={editForm.liveDate} onChange={(e) => setEditForm({ ...editForm, liveDate: e.target.value })} placeholder="liveDate (YYYY-MM-DD)" />
                  <input className="border rounded-md p-2" value={editForm.initialPrice} onChange={(e) => setEditForm({ ...editForm, initialPrice: e.target.value })} placeholder="initialPrice" />
                  <input className="border rounded-md p-2" value={editForm.initialMarketCap} onChange={(e) => setEditForm({ ...editForm, initialMarketCap: e.target.value })} placeholder="initialMarketCap" />
                  <textarea
  className="border rounded-md p-2 col-span-2"
  value={editForm.description}
  onChange={(e) => setEditForm({ ...editForm, description: e.target.value })}
  placeholder="description"
  rows={3}
/>

<input
  className="border rounded-md p-2"
  value={editForm.website}
  onChange={(e) => setEditForm({ ...editForm, website: e.target.value })}
  placeholder="website (https://...)"
/>

<input
  className="border rounded-md p-2"
  value={editForm.twitter}
  onChange={(e) => setEditForm({ ...editForm, twitter: e.target.value })}
  placeholder="twitter (https://x.com/...)"
/>

<input
  className="border rounded-md p-2"
  value={editForm.telegram}
  onChange={(e) => setEditForm({ ...editForm, telegram: e.target.value })}
  placeholder="telegram (https://t.me/...)"
/>

<input
  className="border rounded-md p-2"
  value={editForm.discord}
  onChange={(e) => setEditForm({ ...editForm, discord: e.target.value })}
  placeholder="discord (https://discord.gg/...)"
/>

                  <label className="flex items-center gap-2 text-sm col-span-2">
                    <input
                      type="checkbox"
                      checked={editForm.isLive}
                      onChange={(e) => setEditForm({ ...editForm, isLive: e.target.checked })}
                    />
                    isLive
                  </label>
                </div>
              )}
            </div>
          );
        })}

        {!loading && items.length === 0 && (
          <div className="text-sm text-gray-600">No prelaunch tokens found.</div>
        )}
      </div>

      {msg && (
        <p className={`text-center mt-3 ${msg.includes("✅") ? "text-green-600" : "text-red-500"}`}>
          {msg}
        </p>
      )}
    </div>
  );
};

export default PrelaunchTokenManager;